import { ElementRef, EventEmitter } from '@angular/core';

export abstract class EfInput {
  public abstract elementRef: ElementRef;
  public abstract onFocus: EventEmitter<void>;
  public abstract onBlur: EventEmitter<void>;
  public abstract onMouseEnter: EventEmitter<void>;
  public abstract onMouseLeave: EventEmitter<void>;
}
